import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';

const filtersSmallSize = ' 44px';
const filtersBigSize = '54px';

export const SearchPageFiltersContainer = styled(FlexibleDiv)<{
  $canGoBack?: boolean;
  $isShowHomeFilters: boolean;
}>`
  width: 100%;
  min-width: 0;
  flex-wrap: ${({ $canGoBack }) => ($canGoBack ? 'nowrap' : 'wrap')};
  gap: 8px;

  @media (min-width: ${Breakpoints.tablet}px) {
    flex-wrap: nowrap;
  }

  ${({ $isShowHomeFilters }) =>
    $isShowHomeFilters &&
    css`
      flex-wrap: nowrap;
    `}
`;

export const FilterWrapper = styled.div`
  flex: 1 1 calc(50% - 10px);
  width: calc(50% - 10px);

  ${({ $isPashaLanding }) =>
    $isPashaLanding
      ? css`
          @media (min-width: ${Breakpoints.tablet}px) {
            flex: auto;
          }
        `
      : css`
          @media (min-width: ${Breakpoints.tablet}px) {
            flex: 0 0 auto;

            &:not(:last-of-type) {
              min-width: 80px;
              max-width: 14%;
            }

            &:first-child {
              max-width: 101px;
            }

            &:nth-child(2) {
              max-width: 120px;
            }
          }

          @media (min-width: ${Breakpoints.smallDesktop}px) {
            &:first-child,
            &:nth-child(2) {
              max-width: 164px;
            }
          }
        `}

  > button {
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 14px;
    height: ${filtersSmallSize};
    width: 100%;

    @media (min-width: ${Breakpoints.tablet}px) {
      height: ${filtersBigSize};
    }
  }
`;

export const SearchBarWrapper = styled.div<{
  canGoBack?: boolean;
  $isShowHomeFilters: boolean;
}>`
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  width: ${({ canGoBack }) =>
    canGoBack
      ? `calc(92% - ${filtersSmallSize} - 10px)`
      : `calc(100% - ${filtersSmallSize} - 10px)`};
  height: ${filtersSmallSize};

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 100%;
    height: ${filtersBigSize};
  }

  > div {
    height: inherit;
  }

  ${({ $isShowHomeFilters }) =>
    $isShowHomeFilters &&
    css`
      height: ${filtersBigSize};
    `}
`;

export const GoBackButton = styled.div`
  width: 14px;
  cursor: pointer;
  display: inline-block;
  background: url('/static/images/item/arrow-right.svg') no-repeat center;
  background-size: 16px 16px;
  transform: rotate(180deg);
  -webkit-tap-highlight-color: transparent;
`;

export const filterButtonStyles = (isHomePage: boolean) => css`
  width: ${filtersSmallSize};
  height: ${filtersSmallSize};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};

  path {
    ${({ theme: { colors } }) => {
      const color = colors.text.primary;
      return { fill: color, stroke: color };
    }}
    transition:
      fill 0.2s ease-in-out,
      stroke 0.2s ease-in-out
  }

  &:hover {
    & > span {
      color: ${({ theme }) => theme.colors.systemColors.blue};
    }

    path {
      ${({ theme: { colors } }) => {
        const color = colors.systemColors.blue;
        return { fill: color, stroke: color };
      }}
    }
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    width: ${filtersBigSize};
    height: ${filtersBigSize};
    padding: 17px 17px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 128px;
    padding: 15px;
    > span {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  ${isHomePage &&
  css`
    height: ${filtersBigSize};
    width: ${filtersBigSize};
  `}
`;
